import React from "react";

function AboutSection() {
  return (
    <section id="about" style={{padding:"80px 48px", background:"#fff"}}>
      <div style={{maxWidth:"900px", margin:"0 auto", textAlign:"center"}}>
        <h2 style={{fontSize:"40px", fontWeight:"900", color:"#0f172a", marginBottom:"16px"}}>
          About <span style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent"}}>Sajilo Policy</span>
        </h2>
        <p style={{fontSize:"17px", color:"#64748b", lineHeight:"1.9", marginBottom:"16px"}}>
          Sajilo Policy is Nepal's first digital microinsurance platform built to make insurance accessible to every Nepali — from farmers in Jumla to students in Kathmandu.
        </p>
        <p style={{fontSize:"17px", color:"#64748b", lineHeight:"1.9", marginBottom:"48px"}}>
          We are proud to partner with <strong style={{color:"#0d9488"}}>Himalayan Life Insurance</strong> to bring you instant, affordable, and trusted coverage starting at just Rs 99/week.
        </p>
        <div style={{display:"flex", gap:"24px", justifyContent:"center", flexWrap:"wrap"}}>
          {[
            {icon:"🏔️", title:"Himalayan Life Insurance", desc:"Our trusted insurance partner with 20+ years in Nepal"},
            {icon:"⚡", title:"Instant Coverage", desc:"Get your policy in under 3 minutes"},
            {icon:"💰", title:"Affordable", desc:"Plans starting at just Rs 99/week"},
            {icon:"🔒", title:"100% Secure", desc:"Bank-level encryption for your data and payments"},
          ].map((item, i) => (
            <div key={i} style={{background:"#f0fdfa", border:"2px solid #e2e8f0", borderRadius:"16px", padding:"28px 24px", width:"180px", textAlign:"center"}}>
              <div style={{fontSize:"36px", marginBottom:"12px"}}>{item.icon}</div>
              <h4 style={{color:"#0f172a", fontWeight:"800", marginBottom:"8px", fontSize:"15px"}}>{item.title}</h4>
              <p style={{color:"#64748b", fontSize:"13px", lineHeight:"1.6"}}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutSection;